import { MenuItem, styled } from '@mui/material'

export const MenuItemsStyle = styled(MenuItem)(({ select }) => {
  let background = 'transparent'

  if (select === 'true') {
    background = '#242428'
  }
  return {
    color: '#FFF',
    background,
    leadingTrim: 'both',
    textEdge: 'cap',
    fontFamily: 'Nunito',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: 'normal',
    '&:hover': {
      background
    }
  }
})
